export default {
  APP_NAME: "SafeTripBuilder",
};
